
















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { users } from "../../api/users/users";
import { component } from "../../api/component/component";
@Component({
  name: "AlarmFilters",
  props: {
    filters: {
      dateFrom: "",
      dateTo: "",
      search: "",
      hall: "",
      system: ""
    }
  },
  model: {
    prop: "filters",
    event: "change"
  },
  watch: {
    date: function(val) {
      this.$props.filters.dateFrom = val;
    }
  }
})
export default class AlarmFilters extends Vue {
  public loading: boolean = false;
  public activeName: string = "1";
  public componentList: any[] = [];
  public date: Date = new Date();
  public visibleComponents: any[] = [];
  public halls: any[] = [];
  public systems: any[] = [];
  public groups: any[] = [];
  public codes: any[] = [];
  public descriptions: any[] = [];
  public visibleHalls: any[] = [];
  public visibleSystems: any[] = [];
  public visibleGroups: any[] = [];

  public created() {
    this.$props.filters.dateFrom = new Date(
      new Date().setDate(new Date().getDate() - 10)
    );
  }
  public async mounted() {
    await this.getComponentList();
    this.$props.filters.dateFrom = new Date(
      new Date().setDate(new Date().getDate() - 10)
    );
    this.date = new Date(new Date().setDate(new Date().getDate() - 10));
  }
  public update() {
    this.$forceUpdate();
  }
  public async getComponentList() {
    await component
      .getAllComponents(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then((resp: any) => {
          this.componentList = JSON.parse(JSON.stringify(resp));
          for (const i of this.componentList) {
            if (!this.halls.includes(i.group1)) {
              this.halls.push(i.group1);
              console.log(this.halls);
            }
            if (!this.systems.includes(i.group2)) {
              this.systems.push(i.group2);
            }
            if (!this.groups.includes(i.group3)) {
              this.groups.push(i.group3);
            }
            if (!this.codes.includes(i.group4)) {
              this.codes.push(i.group4);
            }
            if (!this.descriptions.includes(i.group5)) {
              this.descriptions.push(i.group5);
            }
          }
        });
      });
  }
  public remoteMethod(query: string) {
    console.log(this.componentList);
    if (query !== "") {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.visibleComponents = this.componentList.filter(item =>
          item.literal.toLowerCase().includes(query.toLowerCase())
        );
      }, 200);
    } else {
      this.visibleComponents = [];
    }
  }
  public hallMethod(query: string) {
    console.log(this.halls);
    if (query !== "") {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.visibleHalls = this.halls.filter(item =>
          item.toLowerCase().includes(query.toLowerCase())
        );
      }, 200);
    } else {
      this.visibleHalls = [];
    }
  }
  public systemMethod(query: string) {
    console.log(this.systems);
    if (query !== "") {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.visibleSystems = this.systems.filter(item =>
          item.toLowerCase().includes(query.toLowerCase())
        );
      }, 200);
    } else {
      this.visibleSystems = [];
    }
  }
  public groupMethod(query: string) {
    console.log(this.groups);
    if (query !== "") {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.visibleGroups = this.groups.filter(item =>
          item.toLowerCase().includes(query.toLowerCase())
        );
      }, 200);
    } else {
      this.visibleGroups = [];
    }
  }
}
